const ICON_SIZE = '20';

export const COMMON_ICON_STYLE = {
  variant: 'outline' as const,
  padding: '0',
  borderRadius: 'full',
  transition: 'all 0.2s',
};

export const ICON_SIZE_STYLE = {
  width: ICON_SIZE,
  height: ICON_SIZE,
};
